import styled, { css } from 'styled-components';
import { IconContainer } from '../../../../icon';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
const ITEM_COUNT_SIZE = 20;
const ITEM_COUNT_VERTICAL_OFFSET = 6;
const ITEM_COUNT_HORIZONTAL_OFFSET = 16;
const MAX_LABEL_WIDTH = 94;
const TOGGLE_ICON_SIZE = 20;
const STATUS_INDICATOR_SIZE = 11;
const STATUS_INDICATOR_ICON_SIZE = 6;
const STATUS_INDICATOR_OFFSET = 10;
export const navigationActionToggleContainerStyles = ({ theme, $navigationIsOpen, $loginMenuIsOpen, $isActive, }) => css `
	appearance: none;
	position: relative;
	display: ${$navigationIsOpen || $loginMenuIsOpen ? 'none' : 'flex'};
	align-items: center;
	gap: ${pxToRem(theme.spacing['100'])};
	width: auto;
	margin: 0;
	padding: ${pxToRem(theme.spacing['200'])};
	border: none;
	border-radius: ${pxToRem(theme.borderRadius.s)};
	color: ${$isActive ? theme.colors.highlight.textInteractive : theme.colors.medium.textInactive};
	font-weight: bold;
	background-color: transparent;

	&:hover {
		color: ${theme.colors.highlight.textHover};

		${IconContainer}:not([data-indicator]) {
			color: ${theme.colors.base.iconHover};
		}
	}

	&:focus,
	&:active {
		color: ${theme.colors.action.textActive};

		${IconContainer}:not([data-indicator]) {
			color: ${theme.colors.action.iconActive};
		}
	}

	&:active {
		background-color: ${theme.colors.extralight.bgFormField};
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		margin: ${pxToRem(theme.spacing['200'])} 0;
		display: flex;

		&:hover {
			background-color: unset;
			color: ${theme.colors.highlight.textInteractiveOnLight};
		}

		&:focus {
			background-color: unset;
			color: unset;
		}

		&:active {
			color: ${theme.colors.action.textActive};
		}
	}

	&:focus-visible {
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		outline-offset: ${theme.borderWidth.m}px;
	}

	${IconContainer} {
		width: ${pxToRem(TOGGLE_ICON_SIZE)};
		height: ${pxToRem(TOGGLE_ICON_SIZE)};
		color: ${$isActive ? theme.colors.highlight.iconInteractive : theme.colors.medium.iconInactive};
	}
`;
export const NavigationActionToggleContainer = styled(Typography).attrs(({ $isLink }) => {
    return {
        variant: 'body-text-xs',
        tagName: $isLink ? 'a' : 'button',
    };
}) `
	${navigationActionToggleContainerStyles}
`;
/**
 * Navigation action toggle label
 */
export const navigationActionToggleLabelContainerStyles = () => css `
	max-width: ${pxToRem(MAX_LABEL_WIDTH)};
	white-space: nowrap;
`;
export const NavigationActionToggleLabelContainer = styled.span `
	${navigationActionToggleLabelContainerStyles}
`;
/**
 * Navigation action toggle icon wrapper
 */
export const navigationActionToggleIconWrapperContainerStyles = () => css `
	position: relative;
	height: ${pxToRem(ITEM_COUNT_SIZE)};
`;
export const NavigationActionToggleIconWrapperContainer = styled.span `
	${navigationActionToggleIconWrapperContainerStyles}
`;
export const navigationActionToggleStatusIndicatorContainerStyles = ({ theme, $variant, }) => css `
	position: absolute;
	bottom: 0;
	right: ${pxToRem(STATUS_INDICATOR_OFFSET)};
	transform: translate(100%, ${pxToRem(theme.borderWidth['2'])});
	display: flex;
	justify-content: center;
	align-items: center;
	width: ${pxToRem(STATUS_INDICATOR_SIZE)};
	height: ${pxToRem(STATUS_INDICATOR_SIZE)};
	border-radius: ${theme.borderRadius.rounded}%;
	border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.blanc.borderButton};
	color: ${theme.colors.highlight.iconInteractive};
	background-color: ${theme.colors.accent.bgLabel};

	[data-indicator] {
		color: ${theme.colors.blanc.textInverse};
	}

	${$variant === 'logged-in' &&
    css `
		color: ${theme.colors.blanc.textInverse};
		background-color: ${theme.colors.positive.iconNotification};
	`}

	${$variant === 'logged-out' &&
    css `
		color: ${theme.colors.blanc.textInverse};
		background-color: ${theme.colors.error.iconNotification};
	`}

	${$variant === 'recognized' &&
    css `
		color: ${theme.colors.blanc.textInverse};
		background-color: ${theme.colors.highlight.iconButton};
	`}

	${IconContainer} {
		width: ${pxToRem(STATUS_INDICATOR_ICON_SIZE)};
		height: ${pxToRem(STATUS_INDICATOR_ICON_SIZE)};
		min-height: unset;
	}
`;
export const NavigationActionToggleStatusIndicatorContainer = styled.span `
	${navigationActionToggleStatusIndicatorContainerStyles}
`;
/**
 * Navigation action toggle item count
 */
export const navigationActionToggleIconCountContainerStyles = ({ theme }) => css `
	z-index: 1;
	position: absolute;
	top: -${pxToRem(ITEM_COUNT_VERTICAL_OFFSET)};
	right: -${pxToRem(ITEM_COUNT_HORIZONTAL_OFFSET)};
	transform: translate(0, -50%);
	display: flex;
	justify-content: center;
	align-items: center;
	height: ${pxToRem(ITEM_COUNT_SIZE)};
	min-width: ${pxToRem(ITEM_COUNT_SIZE)};
	padding: 0 6px;
	border-radius: ${ITEM_COUNT_SIZE}px;
	color: ${theme.colors.highlight.iconInteractive};
	background-color: ${theme.colors.accent.bgLabel};
`;
export const NavigationActionToggleIconCountContainer = styled(Typography).attrs({
    variant: 'sticker-text-sm',
}) `
	${navigationActionToggleIconCountContainerStyles}
`;
